import api from '@pray/shared/utils/api';

type GetYoutubePlaylistByIdParams = {
  artistId: string;
  contentSeriesId: string;
  offset?: number;
  limit?: number;
};

/* eslint-disable camelcase */
export type GetYoutubePlaylistByIdResponse = {
  responded_at: string;
  next_item: number | null;
  object: 'object';
  data: YoutubePlaylist;
};

/* eslint-disable camelcase */
export type YoutubePlaylist = {
  id: string;
  description: string;
  handle: string;
  image_url: string;
  title: string;
  shared_count: number;
  rss_feed_url: string;
  created_at: string;
  is_visible: boolean;
  content: {
    id: string;
    title: string;
    duration: number;
    image_url: string;
    video_url: string | null;
    is_published: boolean;
    shared_count: number;
    created_at: string;
    published_at: string;
    first_published_at: string;
    status: 'processing' | 'completed' | 'failed' | null;
    error_message?: string;
  }[];
};

export async function getYoutubePlaylistById({
  artistId,
  contentSeriesId,
  offset = 0,
  limit = 25,
}: GetYoutubePlaylistByIdParams): Promise<GetYoutubePlaylistByIdResponse> {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentSeriesId) throw Error('Content Series ID is required');

  const params: Pick<GetYoutubePlaylistByIdParams, 'limit' | 'offset'> = { limit };

  if (Number.isInteger(offset) && offset >= 0) {
    params.offset = offset;
  }

  const url = `/web/studio/artists/${artistId}/content-series/${contentSeriesId}/youtube`;
  const response = await api.executeGetRequest<GetYoutubePlaylistByIdResponse>(url, params);

  return response.data;
}
